const STORAGE_PREFIX = 'superadmin_cabinet_pinned_projects_';

export function loadPinnedProjectIds(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${userId}`);
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
  } catch {
    return [];
  }
}

export function savePinnedProjectIds(userId, ids) {
  if (!userId) return;
  localStorage.setItem(`${STORAGE_PREFIX}${userId}`, JSON.stringify(ids));
}

export function togglePinnedProjectId(userId, projectId, currentIds) {
  const id = Number(projectId);
  const next = currentIds.includes(id)
    ? currentIds.filter((x) => x !== id)
    : [...currentIds, id];
  savePinnedProjectIds(userId, next);
  return next;
}

export function prunePinnedProjectIds(pinnedIds, projects) {
  const existing = new Set((projects || []).map((p) => Number(p.id)));
  return pinnedIds.filter((id) => existing.has(id));
}

export function sortProjectsWithPins(projects, pinnedIds) {
  const pinOrder = pinnedIds.map((id) => Number(id));
  const pinSet = new Set(pinOrder);
  const pinned = pinOrder
    .map((id) => projects.find((p) => Number(p.id) === id))
    .filter(Boolean);
  const unpinned = projects.filter((p) => !pinSet.has(Number(p.id)));
  return [...pinned, ...unpinned];
}
